export default __webpack_public_path__ + "static/markedwaxdifficult-8b911f956bfacffc7ed1c96cc55f1d96.png";